export default __webpack_public_path__ + "e53f9fc2753c6f765af6aa83490d520e.png";